import React from "react";
import { Spin } from "antd";
import { currencyDisplay } from "../../../../utils/helpers";

interface Props {
  /** Left side: the running total with the breakdown link (selection pages); steps leave it out. */
  total?: number;
  loading?: boolean;
  onShowBreakdown?: () => void;
  children: React.ReactNode;
}

// Fixed bottom bar shared by every checkout page; the buttons come in as children.
export default function BookingFooter({ total, loading, onShowBreakdown, children }: Props) {
  return (
    <footer className="gt-footer">
      <div className="gt-footer__inner">
        {onShowBreakdown ? (
          <div className="gt-footer__total">
            <span>Total</span>
            <strong>
              {loading ? <Spin size="small" /> : total === undefined ? "–" : currencyDisplay("MYR", total)}
              <small> (incl. taxes & fees)</small>
            </strong>
            <button type="button" onClick={onShowBreakdown}>Price breakdown</button>
          </div>
        ) : <span />}
        <div className="gt-footer__actions">{children}</div>
      </div>
    </footer>
  );
}
